import type { Section } from '@common/formEngine/formEngine.types';
import type { NullablePrimitives } from '@common/utils/utilityTypes';
import type { ProcessActivityAsset } from '@common/validation/processActivityAsset';
import { imageMovieAndPdfExtensions } from '@common/utils/fileExtensions';

export type EchographyConsultRequestData = NullablePrimitives<{
    anamnese_indicatie_echo: string;
    assets: ProcessActivityAsset[];
    bevinding_toelichting: string;
    bevinding_vraag: string;
    bevinding_werkdiagnose: string;
    doorverwezen_zonder_ksyos: boolean;
}>;

export const echographyConsultRequestSections: Section<EchographyConsultRequestData>[] = [
    {
        alertText: "Je kunt hier foto's en video's uploaden.",
        fields: [
            {
                acceptExtensions: imageMovieAndPdfExtensions,
                isRequired: true,
                key: 'assets',
                label: 'Echobeelden',
                type: 'assets',
            },
        ],
        title: 'Onderzoek',
    },
    {
        fields: [
            {
                isRequired: true,
                key: 'anamnese_indicatie_echo',
                label: 'Indicatie echo',
                type: 'textArea',
            },
        ],
        title: 'Anamnese',
    },
    {
        fields: [
            {
                key: 'bevinding_werkdiagnose',
                label: 'Werkdiagnose',
                type: 'textInput',
            },
            {
                key: 'bevinding_toelichting',
                label: 'Toelichting',
                type: 'textArea',
            },
            {
                isRequired: true,
                key: 'bevinding_vraag',
                label: 'Vraag',
                type: 'textArea',
            },
        ],
        title: 'Bevinding',
    },
    {
        fields: [
            {
                key: 'doorverwezen_zonder_ksyos',
                label: 'Had je deze patiënt zonder Ksyos doorverwezen naar de specialist?',
                type: 'boolean',
            },
        ],
        title: 'Overig',
    },
];
